module.exports = "/packs/000-f5545ebba7643d7652afcdeba9716f44.jpg";